import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { TiArrowBack } from "react-icons/ti";
import { patientRegistration } from "../../api/api";
import toast from "react-hot-toast";
import { TextField } from "@mui/material";

const AddMembersPage = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    RBAuthKey: "RBDWAh!Q1s74e",
    user_id: "",
    Mobile_no: localStorage.getItem("userMobile") || "",
    Alt_mobile_no: "",
    FName: "",
    LName: "",
    Email: "",
    Dateofbirth: "",
    dob: "",
    Gender: "",
    Address: "",
    Landmark: "",
    State: "",
    City: "",
    ZipCode: "",
    Reg_status: "0",
    Pat_status: "0",
    IsMobileregister: "y",
    Registerdate: new Date().toISOString().split("T")[0],
    opt_check: false,
  });

  //define  validation

  const validateForm = () => {
    const newErrors = {};

    // Mobile Number (required)
    if (!formData.Mobile_no.trim()) {
      newErrors.Mobile_no = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(formData.Mobile_no)) {
      newErrors.Mobile_no = "Mobile number must be 10 digits";
    }

    // First Name (required)
    if (!formData.FName.trim()) {
      newErrors.FName = "First name is required";
    } else if (formData.FName.trim().length < 2) {
      newErrors.FName = "First name must be at least 2 characters";
    }

    // Last Name (required)
    if (!formData.LName.trim()) {
      newErrors.LName = "Last name is required";
    } else if (formData.LName.trim().length < 2) {
      newErrors.LName = "Last name must be at least 2 characters";
    }

    // Date of Birth (required)
    if (!formData.dob) {
      newErrors.dob = "Date of birth is required";
    } else {
      const dobDate = new Date(formData.dob);
      const today = new Date();
      const age = today.getFullYear() - dobDate.getFullYear();

      if (age < 0 || age > 120) {
        newErrors.dob = "Please enter a valid date of birth";
      }
    }

    // Email (required)
    if (!formData.Email.trim()) {
      newErrors.Email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email)) {
      newErrors.Email = "Invalid email format";
    }

    // Alternative Mobile (optional, but validate if provided)
    if (
      formData.Alt_mobile_no.trim() &&
      !/^[0-9]{10}$/.test(formData.Alt_mobile_no)
    ) {
      newErrors.Alt_mobile_no = "Alternative mobile must be 10 digits";
    }

    // Gender (required)
    if (!formData.Gender) {
      newErrors.Gender = "Please select a gender";
    }

    // Address (required)
    if (!formData.Address.trim()) {
      newErrors.Address = "Address is required";
    }

    // Landmark (optional)
    // No validation needed

    // State (required)
    if (!formData.State.trim()) {
      newErrors.State = "State is required";
    }

    // City (required)
    if (!formData.City.trim()) {
      newErrors.City = "City is required";
    }

    // Pin Code (required)
    if (!formData.ZipCode.trim()) {
      newErrors.ZipCode = "Pin code is required";
    } else if (!/^[0-9]{6}$/.test(formData.ZipCode)) {
      newErrors.ZipCode = "Pin code must be 6 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // call api
  const addMember = async (data) => {
    try {
      setLoading(true);
      setMessage("");

      const res = await patientRegistration(data);

      if (res?.data?.status === "success") {
        setMessage(res?.data?.message || "registration successfull");
        // setShowPopup(true);
        setFormData({
          RBAuthKey: "RBDWAh!Q1s74e",
          user_id: "",
          Mobile_no: "",
          Alt_mobile_no: "",
          FName: "",
          LName: "",
          Email: "",
          Dateofbirth: "",
          dob: "",
          Gender: "",
          Address: "",
          Landmark: "",
          State: "",
          City: "",
          ZipCode: "",
          Reg_status: "0",
          Pat_status: "0",
          IsMobileregister: "y",
          Registerdate: new Date().toISOString().split("T")[0],
          opt_check: false,
        });
        setErrors({});
        toast.success(res?.data?.message);
      } else {
        setMessage("");
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Error submitting contact request:", err);
      setMessage("Server error. Please try again later.");
      toast.error(
        err?.response?.data?.message || "Server error. Please try again later."
      );
    } finally {
      setLoading(false);
    }
  };

  //call comlete
  console.log("message==>", message);

  const navigator = useNavigate();
  // Add this function at the top of your component, after state declarations
  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "";
    const dateParts = dateString.split("-");
    return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
  };

  // Use it in handleSubmit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.opt_check) {
      toast.error("Please check the consent box before proceeding.");
      return; // stop further execution
    }

    const dataToSubmit = {
      ...formData,
      Dateofbirth: formatDateToDDMMYYYY(formData.dob),
      Registerdate: formatDateToDDMMYYYY(formData.Registerdate),
      dob: formatDateToDDMMYYYY(formData.dob),
    };

    addMember(dataToSubmit);
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  console.log("formData====>", formData);
  console.log("message-==>", message);

  // return (
  //   <>
  //     <div className="edit-profile-container">
  //       <div className="profile-header">
  //         <h2>Add Member</h2>
  //       </div>

  //       <div className="edit-profile-form-wrapper">
  //         <form className="edit-profile-form" onSubmit={handleSubmit}>
  //           {/* Mobile */}
  //           <div className="form-group half-width">
  //             <label>Mobile Number</label>
  //             <input
  //               type="text"
  //               name="Mobile_no"
  //               placeholder="Mobile"
  //               value={formData.Mobile_no}
  //               onChange={handleChange}
  //               readOnly
  //             />
  //           </div>

  //           <div className="form-row">
  //             <div className="form-group half-width">
  //               <label>First Name</label>
  //               <input
  //                 type="text"
  //                 name="FName"
  //                 placeholder="Enter First Name"
  //                 value={formData.FName}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //             <div className="form-group half-width">
  //               <label>Last Name</label>
  //               <input
  //                 type="text"
  //                 name="LName"
  //                 placeholder="Enter Last Name"
  //                 value={formData.LName}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //             <div className="form-group">
  //               <label>Date of Birth</label>
  //               <input
  //                 type="date"
  //                 name="Dateofbirth"
  //                 value={formData.Dateofbirth}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //           </div>

  //           <div className="form-row">
  //             <div className="form-group">
  //               <label>Email ID</label>
  //               <input
  //                 type="email"
  //                 name="Email"
  //                 placeholder="Mail ID"
  //                 value={formData.Email}
  //                 onChange={handleChange}
  //               />
  //             </div>

  //             <div className="form-group half-width">
  //               <label>Alternative Mobile</label>
  //               <input
  //                 type="number"
  //                 name="Alt_mobile_no"
  //                 placeholder="Alternative Mobile Number"
  //                 value={formData.Alt_mobile_no}
  //                 onChange={handleChange}
  //                 maxLength={10}
  //               />
  //             </div>
  //             <div className="form-group">
  //               <label>Gender</label>
  //               <div className="gender-options">
  //                 {["M", "F", "other"].map((g) => (
  //                   <label key={g}>
  //                     <input
  //                       type="radio"
  //                       name="Gender"
  //                       value={g}
  //                       checked={formData.Gender === g}
  //                       onChange={handleChange}
  //                     />{" "}
  //                     {g.charAt(0).toUpperCase() + g.slice(1)}
  //                   </label>
  //                 ))}
  //               </div>
  //             </div>
  //           </div>

  //           {/* Address */}
  //           <div className="form-row">
  //             <div className="form-group half-width">
  //               <label>Address</label>
  //               <input
  //                 type="text"
  //                 name="Address"
  //                 placeholder="Enter Address"
  //                 value={formData.Address}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //             <div className="form-group half-width">
  //               <label>Landmark</label>
  //               <input
  //                 type="text"
  //                 name="Landmark"
  //                 placeholder="Enter Landmark"
  //                 value={formData.Landmark}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //           </div>

  //           {/* State / City / Pincode */}
  //           <div className="form-row">
  //             <div className="form-group">
  //               <label>State</label>
  //               <input
  //                 type="text"
  //                 name="State"
  //                 placeholder="State"
  //                 value={formData.State}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //             <div className="form-group">
  //               <label>City</label>
  //               <input
  //                 type="text"
  //                 name="City"
  //                 placeholder="City"
  //                 value={formData.City}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //             <div className="form-group">
  //               <label>Pin Code</label>
  //               <input
  //                 type="text"
  //                 name="ZipCode"
  //                 placeholder="Pin Code"
  //                 value={formData.ZipCode}
  //                 onChange={handleChange}
  //               />
  //             </div>
  //           </div>

  //           {/* Consent */}
  //           {/* <div className="consent-checkbox">
  //                           <label>
  //                               <input type="checkbox" className="mr-2" />
  //                               I allow <b>RB Diagnostic</b> to Call / Whatsapp / Mail / SMS
  //                           </label>
  //                       </div> */}

  //           {/*  */}
  //           <div className="consent-checkbox">
  //             <label>
  //               <input
  //                 type="checkbox"
  //                 className="mr-2"
  //                 name="opt_check"
  //                 checked={formData.opt_check}
  //                 onChange={handleChange}
  //               />
  //               I allow <b>RB Diagnostic</b> to Call / Whatsapp / Mail / SMS
  //             </label>
  //             {errors.opt_check && (
  //               <span className="error-message">{errors.opt_check}</span>
  //             )}
  //           </div>

  //           {/*  */}

  //           {/* Buttons */}
  //           <div className="form-actions">
  //             <button
  //               type="button"
  //               className="rbdButton reset-Btn"
  //               onClick={() => navigator(-1)}
  //             >
  //               <span className="btn-text">
  //                 <TiArrowBack />
  //               </span>
  //             </button>
  //             <button type="submit" className="rbdButton btn">
  //               <span className="btn-text">Submit</span>
  //             </button>
  //           </div>
  //         </form>
  //       </div>
  //     </div>
  //   </>
  // );
  return (
    <>
      <div className="edit-profile-container">
        <div className="profile-header">
          <h2>Add Member</h2>
        </div>

        <div className="edit-profile-form-wrapper">
          <form className="edit-profile-form" onSubmit={handleSubmit}>


            <div className="edit-form-row">
              <div className="form-group half-width form-group-dash">
                <label>Mobile Number</label>
                <input
                  type="text"
                  name="Mobile_no"
                  placeholder="Mobile"
                  value={formData.Mobile_no}
                  onChange={handleChange}
                  readOnly
                />
              </div>


              <div className="form-group half-width form-group-dash">
                <label>First Name</label>
                <input
                  type="text"
                  name="FName"
                  placeholder="Enter First Name"
                  value={formData.FName}
                  onChange={handleChange}
                />
              </div>


              <div className="form-group half-width form-group-dash">
                <label>Last Name</label>
                <input
                  type="text"
                  name="LName"
                  placeholder="Enter Last Name"
                  value={formData.LName}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group half-width form-group-dash">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="Dateofbirth"
                  value={formData.Dateofbirth}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="edit-form-row background-edit-form-row">

              <div className="form-group half-width">
                <label>Address</label>
                <input
                  type="text"
                  name="Address"
                  placeholder="Enter Address"
                  value={formData.Address}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>State</label>
                <input
                  type="text"
                  name="State"
                  placeholder="State"
                  value={formData.State}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  name="City"
                  placeholder="City"
                  value={formData.City}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Pin Code</label>
                <input
                  type="text"
                  name="ZipCode"
                  placeholder="Pin Code"
                  value={formData.ZipCode}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Email ID</label>
                <input
                  type="email"
                  name="Email"
                  placeholder="Mail ID"
                  value={formData.Email}
                  onChange={handleChange}
                />
              </div>


              <div className="form-group half-width">
                <label>Alternative Mobile</label>
                <input
                  type="number"
                  name="Alt_mobile_no"
                  placeholder="Alternative Mobile Number"
                  value={formData.Alt_mobile_no}
                  onChange={handleChange}
                  maxLength={10}
                />
              </div>



              <div className="form-group">
                <label>Gender</label>
                <div className="gender-options">
                  {["M", "F"].map((g) => (
                    <label key={g}>
                      <input
                        type="radio"
                        name="Gender"
                        value={g}
                        checked={formData.Gender === g}
                        onChange={handleChange}
                      />{" "}
                      {g.charAt(0).toUpperCase() + g.slice(1)}
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-group half-width">
                <label>Landmark</label>
                <input
                  type="text"
                  name="Landmark"
                  placeholder="Enter Landmark"
                  value={formData.Landmark}
                  onChange={handleChange}
                />
              </div>

            </div>

            <div className="form-row">
              {/* <div className="form-group half-width">
                <label>First Name</label>
                <input
                  type="text"
                  name="FName"
                  placeholder="Enter First Name"
                  value={formData.FName}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group half-width">
                <label>Last Name</label>
                <input
                  type="text"
                  name="LName"
                  placeholder="Enter Last Name"
                  value={formData.LName}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Date of Birth</label>
                <input
                  type="date"
                  name="Dateofbirth"
                  value={formData.Dateofbirth}
                  onChange={handleChange}
                />
              </div> */}
            </div>

            <div className="form-row">
              {/* <div className="form-group">
                <label>State</label>
                <input
                  type="text"
                  name="State"
                  placeholder="State"
                  value={formData.State}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  name="City"
                  placeholder="City"
                  value={formData.City}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>Pin Code</label>
                <input
                  type="text"
                  name="ZipCode"
                  placeholder="Pin Code"
                  value={formData.ZipCode}
                  onChange={handleChange}
                />
              </div> */}
            </div>



            {/*  */}
            <div className="consent-checkbox">
              <label>
                <input
                  type="checkbox"
                  className="mr-2"
                  name="opt_check"
                  checked={formData.opt_check}
                  onChange={handleChange}
                />
                I allow <b>RB Diagnostic</b> to Call / Whatsapp / Mail / SMS
              </label>
              {errors.opt_check && (
                <span className="error-message">{errors.opt_check}</span>
              )}
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="rbdButton reset-Btn submit-profile-btn"
                onClick={() => navigator(-1)}
              >
                <span className="btn-text">
                  Back
                </span>
              </button>
              <button type="submit" className="rbdButton submit-profile-btn">
                <span className="btn-text">Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddMembersPage;
